export * from '@ckeditor/ckeditor5-media-embed'
